import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';
import H from '../H/H';

/**
 * `Group` is a container for grouping components together. Groups may have an optional title or counter.
 *
 * Common components placed inside groups will automatically get the correct spacing between them so use this component
 * whenever you want to lay out components that are naturally grouped together.
 *
 * @property {node} children The components you want to group together.
 * @property {string} className The class name of this container. Will be appended "core-group".
 * @property {number} count An optional counter displayed to the right of the title. No counter is displayed by default.
 * @property {number} level The level of the group title, 1 => `h1`, 2 => `h2`, etc. Defaults to 3 (`h3`).
 * @property {string} title The group title. Defaults to no title.
 *
 * @see H
 */
export default class Group extends Component {

  static displayName = 'Group';

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    count: PropTypes.number,
    level: PropTypes.number,
    title: PropTypes.string,
  };

  render() {
    const { children, className, count, level, title, ...rest } = this.props;

    return (
      <div className={cx('core-group', className)} {...rest}>
        {title && <H level={level} count={count}>{title}</H>}
        {children}
      </div>
    );
  }

}
